import { Link } from "react-router-dom";

export const InternationalCooperationAndInternationalizationConst = {
  path: "/single-page/international-cooperation-and-internationalization",
  title: "МЕЖДУНАРОДНОЕ СОТРУДНИЧЕСТВО И ИНТЕРНАЦИОНАЛИЗАЦИЯ",
  contentJSX: (
    <>
      <h2>МЕЖДУНАРОДНОЕ СОТРУДНИЧЕСТВО И ИНТЕРНАЦИОНАЛИЗАЦИЯ</h2>
      <p>Общий объём: 144 академических часа</p>
      <p>Формат: онлайн / гибрид / выездной интенсив</p>
      <p>Язык: русский / английский</p>
      <p>Итог: Международный сертификат</p>
      <h2>I. ГЛОБАЛЬНЫЕ ИНИЦИАТИВЫ И ПРОГРАММЫ — 36 ЧАСОВ</h2>
      <ul className="number">
        <li>Erasmus+, Horizon Europe, DAAD: цели, процедуры, участие – 18 ч</li>
        <li>Международные ассоциации и рейтинги – 6 ч</li>
        <li>Международное позиционирование вуза – 6 ч</li>
        <li>Выстраивание устойчивых партнёрств – 6 ч</li>
      </ul>
      <h2>II. ПРОЕКТНАЯ РАБОТА И ГРАНТЫ — 30 ЧАСОВ</h2>
      <ul className="number">
        <li>Подготовка проектных заявок – 12 ч</li>
        <li>Финансовое планирование и отчётность – 6 ч</li>
        <li>Координация международных проектов – 6 ч</li>
        <li>Работа с платформами заявок (EU Funding, PRIMA, eForm) – 6 ч</li>
      </ul>
      <h2>III. МОБИЛЬНОСТЬ И АКАДЕМИЧЕСКИЙ ОБМЕН — 24 ЧАСА</h2>
      <ul className="number">
        <li>Студенческая и преподавательская мобильность – 12 ч</li>
        <li>Визовая поддержка, логистика, сопровождение – 6 ч</li>
        <li>Инструменты поддержки и стипендии – 6 ч</li>
      </ul>
      <h2>IV. ВНЕДРЕНИЕ ИНТЕРНАЦИОНАЛЬНЫХ ПРОГРАММ — 30 ЧАСОВ</h2>
      <ul className="number">
        <li>Совместные степени и двойные дипломы – 12 ч</li>
        <li>EMI (English Medium Instruction) – 6 ч</li>
        <li>Разработка курсов с международной компонентой – 6 ч</li>
        <li>Преподавание в мультиязычной среде – 6 ч</li>
      </ul>
      <h2>V. ИТОГОВЫЙ ПРОЕКТ — 24 ЧАСА</h2>
      <ul className="number">
        <li>Стратегия интернационализации вуза – 12 ч</li>
        <li>Презентация, обратная связь и доработка – 12 ч</li>
      </ul>
      <br />
      <Link to={"/apply-online"} className="btn-default reverse">
        Оставить заявку
      </Link>
    </>
  ),
  contentSearch: `
    МЕЖДУНАРОДНОЕ СОТРУДНИЧЕСТВО И ИНТЕРНАЦИОНАЛИЗАЦИЯ 
    Общий объём: 144 академических часа
    Формат: онлайн / гибрид / выездной интенсив
    Язык: русский / английский
    Итог: Международный сертификат
    I. ГЛОБАЛЬНЫЕ ИНИЦИАТИВЫ И ПРОГРАММЫ — 36 ЧАСОВ
    Erasmus+, Horizon Europe, DAAD: цели, процедуры, участие – 18 ч
    Международные ассоциации и рейтинги – 6 ч
    Международное позиционирование вуза – 6 ч
    Выстраивание устойчивых партнёрств – 6 ч
    II. ПРОЕКТНАЯ РАБОТА И ГРАНТЫ — 30 ЧАСОВ
    Подготовка проектных заявок – 12 ч
    Финансовое планирование и отчётность – 6 ч
    Координация международных проектов – 6 ч
    Работа с платформами заявок (EU Funding, PRIMA, eForm) – 6 ч
    III. МОБИЛЬНОСТЬ И АКАДЕМИЧЕСКИЙ ОБМЕН — 24 ЧАСА
    Студенческая и преподавательская мобильность – 12 ч
    Визовая поддержка, логистика, сопровождение – 6 ч
    Инструменты поддержки и стипендии – 6 ч
    IV. ВНЕДРЕНИЕ ИНТЕРНАЦИОНАЛЬНЫХ ПРОГРАММ — 30 ЧАСОВ
    Совместные степени и двойные дипломы – 12 ч
    EMI (English Medium Instruction) – 6 ч
    Разработка курсов с международной компонентой – 6 ч
    Преподавание в мультиязычной среде – 6 ч
    V. ИТОГОВЫЙ ПРОЕКТ — 24 ЧАСА
    Стратегия интернационализации вуза – 12 ч
    Презентация, обратная связь и доработка – 12 ч
  `,
};
